/*
 * cadabra-mobile-fixes.js
 * ---------------------------------------------------------------------------
 * Mobile experience enhancements for Cadabra India (Copy of Cadabra v13).
 *
 * Scope:
 *  - PDP only: injects a sticky bottom CTA bar (price + Add to cart + Add to Quote)
 *    after the buy-buttons region scrolls past the viewport.
 *  - Uses IntersectionObserver. No layout thrash; no main-thread blocking work.
 *  - Hard-gated to mobile widths (<= 780px) so desktop is untouched.
 *  - No-op on every non-product template.
 *
 * Does NOT:
 *  - Re-implement add-to-cart logic — clicking the sticky cart button forwards
 *    the click to the existing in-page Add-to-cart button.
 *  - Override existing sticky-addtocart components (component-sticky-addtocart.css)
 *    — appears as a sibling, lower z-index, dismissed when buy-buttons re-enter view.
 *  - Touch desktop, search results, blog posts, cart drawer, or any form.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  // Exit on non-product pages.
  var body = document.body;
  if (!body || !body.classList.contains('template-product')) return;

  // Exit on desktop.
  var MQ = window.matchMedia('(max-width: 780px)');
  if (!MQ.matches) {
    // Listen for viewport changes in case the user resizes.
    var setup = function () {
      if (MQ.matches) init();
      MQ.removeEventListener('change', setup);
    };
    MQ.addEventListener('change', setup);
    return;
  }

  function init() {
    // Find the in-page Add-to-cart button. The theme uses .product-form__submit
    // inside <product-form> or .btn--add-to-cart depending on the variant.
    var inPageCart =
      document.querySelector('product-form .product-form__submit') ||
      document.querySelector('.product-form__submit') ||
      document.querySelector('.btn--add-to-cart');

    if (!inPageCart) return;

    // Find the in-page product title and price for the sticky bar.
    var titleEl =
      document.querySelector('.product__title h1') ||
      document.querySelector('.product__title') ||
      document.querySelector('h1.product__title');

    var priceEl =
      document.querySelector('.product__info .price__regular .price-item--regular') ||
      document.querySelector('.product__info .price .price-item--regular') ||
      document.querySelector('.price__container .price-item--regular') ||
      document.querySelector('.price-item--regular');

    var productTitle = titleEl ? titleEl.textContent.trim() : (document.title || '');
    var productPriceText = priceEl ? priceEl.textContent.trim() : '';

    // Read SKU from the visible variant ID input if available.
    var variantInput = document.querySelector('input[name="id"]');
    var variantId = variantInput ? variantInput.value : '';
    var productSlugMatch = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    var productSlug = productSlugMatch ? productSlugMatch[1] : '';

    // Build the Quote URL with productSlug + variant + title for prefill.
    var quoteUrl =
      '/pages/request-quote'
      + '?product=' + encodeURIComponent(productSlug)
      + (variantId ? '&variant=' + encodeURIComponent(variantId) : '')
      + (productTitle ? '&title=' + encodeURIComponent(productTitle) : '');

    // Build the sticky bar.
    var bar = document.createElement('div');
    bar.className = 'cadabra-pdp-stickybar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Product purchase actions');
    bar.innerHTML =
      '<span class="cadabra-pdp-stickybar__price" aria-label="Price">'
      + (productPriceText || '')
      + '</span>'
      + '<a class="cadabra-pdp-stickybar__quote" href="' + quoteUrl + '" rel="noopener">'
      + 'Add to Quote'
      + '</a>'
      + '<button type="button" class="cadabra-pdp-stickybar__cart" aria-label="Add to cart">'
      + (inPageCart.querySelector('span') ? inPageCart.querySelector('span').textContent.trim() : 'Add to cart')
      + '</button>';

    document.body.appendChild(bar);
    document.body.classList.add('cadabra-pdp-stickybar-active');

    // Forward sticky cart click to the in-page button.
    bar.querySelector('.cadabra-pdp-stickybar__cart').addEventListener('click', function (e) {
      e.preventDefault();
      inPageCart.click();
    });

    // Toggle visibility based on whether the in-page Add-to-cart button is
    // visible in the viewport. When it's OFF screen, show the sticky bar.
    if (!('IntersectionObserver' in window)) {
      // Fallback: show sticky bar after 600px scroll.
      window.addEventListener(
        'scroll',
        function () {
          bar.classList.toggle('is-visible', window.pageYOffset > 600);
        },
        { passive: true }
      );
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // Sticky bar visible when the in-page Add-to-cart button is NOT in view.
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      {
        // Intersection threshold: trigger when the button leaves the viewport top.
        rootMargin: '0px 0px -60% 0px',
        threshold: 0,
      }
    );
    io.observe(inPageCart);
  }

  // Run after DOM ready (page may use deferred Liquid).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
